import React, { useEffect, useRef, useState } from "react";
import "./HistorySection.css";

export default function HistorySection() {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  const [history, setHistory] = useState({
    years: "",
    label: "",
    description: "",
    tagline: "",
    image: ""
  });

  /* ===============================
     FETCH HISTORY DATA
  ================================ */
  useEffect(() => {
    fetch("https://pharma.accendiatechnologies.com/batterjee/getvideos.php")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success" && data.history) {
          setHistory({
            years: data.history.years || "",
            label: data.history.label || "",
            description: data.history.description || "",
            tagline: data.history.tagline || "",
            image: data.history.image || ""
          });
        }
      })
      .catch(() => {});
  }, []);

  /* ===============================
     OBSERVER (ANIMATION TRIGGER)
  ================================ */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActive(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`history-section ${active ? "active" : ""}`}
    >
      <div className="history-inner">

        {/* LEFT CONTENT */}
        <div className="history-text">
          <div className="years">
            <span className="number">{history.years}</span>
            <span className="label">{history.label}</span>
          </div>

          <div
            dangerouslySetInnerHTML={{ __html: history.description }}
          />

          <em className="tagline">{history.tagline}</em>
        </div>

        {/* RIGHT IMAGE */}
        <div className="history-image">
          {history.image && (
            <img src={history.image} alt="Company History" />
          )}
        </div>

      </div>
    </section>
  );
}
